import React, { useEffect, useState } from 'react'
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from "@mui/material/TextField";
import { getAllDocsInCollection } from '../../firebase';
import ModalContainer from './ModalContainer';
import Colors from '../../colors';
import { DESIGNATED_FIRST_AIDERS, FIRST_AID_KIT_LOCATION, LOCAL_GOV_CONTACT, MUSTER_POINT, NEAREST_HOSPITAL, SEARCH_AND_RESCUE, SITE_CONTACT } from '../../constants';
import { Box, Typography } from '@mui/material';
import ModalButton from './Buttons/normal/ModalButton';
import { useNavigate } from 'react-router';

const filter = createFilterOptions();

function LocationModal({ isVisible, setIsVisible, defaultValue, dataCallback, isAdmin }) {
    const [locations, setLocations] = useState([]);
    const [value, setValue] = useState({ locationName: defaultValue });
    const [erpWillChange, setErpWillChange] = useState([]);
    const [error, setError] = useState(false);

    const navigate = useNavigate();



    useEffect(() => {
        setValue({ locationName: defaultValue });
    }, [defaultValue]);

    useEffect(() => {
        async function getLocation() {
            const locationsData = await getAllDocsInCollection('Locations');
            setLocations(locationsData);
        }
        getLocation();
    }, [])

    useEffect(() => {
        if ({ locationName: value } !== defaultValue) {
            const erpTitlesByProperty = {
                firstAidLocation: FIRST_AID_KIT_LOCATION,
                designatedFirstAiders: DESIGNATED_FIRST_AIDERS,
                musterPoint: MUSTER_POINT,
                nearestHospital: NEAREST_HOSPITAL,
                searchAndRescue: SEARCH_AND_RESCUE,
                localGovContact: LOCAL_GOV_CONTACT,
                siteContact: SITE_CONTACT,
            };

            const erpsThatWillChange = [];
            for (const property in value) {
                if (erpTitlesByProperty.hasOwnProperty(property)) {
                    const title = erpTitlesByProperty[property];
                    erpsThatWillChange.push(title);
                }
            };
            if (erpsThatWillChange.length > 0) {
                setErpWillChange(erpsThatWillChange);
            } else {
                setErpWillChange([]);
            }
        }
    }, [value, defaultValue]);

    const saveButtonOnClickHandler = () => {
        if (value === null || value === undefined || value.locationName === '') {
            setError(true);
            setTimeout(() => {
                setError(false);
            }, 2000)
        } else {
            dataCallback(value);
            setIsVisible(false);
        }
    };

    const btnGroupStyles = {
        marginTop: '20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
    }

    const warningMsgStyles = {
        fontFamily: 'Jost',
        textAlign: 'center',
        fontWeight: 500,
        fontStyle: 'italic'
    };

    return (
        <ModalContainer isVisible={isVisible} setIsVisible={setIsVisible} title={"Edit Location"}>
            <Autocomplete
                value={value}
                onChange={(event, newValue) => {
                    if (newValue === null || newValue === undefined) {

                    } else if (typeof newValue === 'string') {
                        setValue({
                            locationName: newValue
                        });
                    } else if (newValue && newValue.inputValue) {
                        // Create a new value from the user input
                        setValue({
                            locationName: newValue.inputValue
                        });
                    } else {
                        delete newValue.id;
                        setValue(newValue);
                    }
                }}
                filterOptions={(options, params) => {
                    const filtered = filter(options, params);

                    const { inputValue } = params;
                    // Suggest the creation of a new value
                    const isExisting = options.some((option) => inputValue === option.locationName);
                    if (inputValue !== '' && !isExisting) {
                        filtered.push({
                            inputValue,
                            locationName: `Add "${inputValue}" as Location`,
                        });
                    }

                    return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                options={locations}
                getOptionLabel={(option) => {
                    // Value selected with enter, right from the input
                    if (typeof option === 'string') {
                        return option;
                    }
                    // Add "xxx" option created dynamically
                    if (option.inputValue) {
                        return option.inputValue;
                    }
                    // Regular option
                    return option.locationName;
                }}
                renderOption={(props, option) => <li {...props}>{option.locationName}</li>}
                sx={{
                    width: 300,
                    border: error ? '2px solid red' : Colors.white,
                    borderRadius: '4px'
                }}
                freeSolo
                renderInput={(params) => (
                    <TextField {...params} label="Location" />
                )}
            />
            {erpWillChange.length > 0 && (
                <Typography sx={warningMsgStyles}>
                    {"Here's what will change in your"}
                    <br />
                    {'Emergency Response Plan:'}
                    <br />
                    {erpWillChange.map((erp) => (
                        <React.Fragment key={erp}>
                            <span style={{ color: 'red' }}>{erp}</span>
                            <br />
                        </React.Fragment>
                    ))}
                </Typography>
            )}

            <Box sx={btnGroupStyles}>
                {isAdmin && <ModalButton
                    onClick={() => navigate('/locations')}
                    color={Colors.blue}
                    fontSize={'1.1rem'}>
                    Create New Location
                </ModalButton>}
                <ModalButton
                    onClick={saveButtonOnClickHandler}
                    color={Colors.green}
                    fontSize={'1.1rem'}>
                    Save
                </ModalButton>
            </Box>
        </ModalContainer>
    )
}

export default LocationModal
